import { Promise } from 'es6-promise';

import { MAV } from '../../constants';
import FSA from '../FSA';
import { mavRequest } from './requestFactory';

interface ISystemEventsMap {
    nodeId?: ISystemEvents[]
}

interface ISystemEvents {
    nodeId?: string
}

interface IParams {
    containerIds: string[],
    start: Date,
    end: Date,
}

function fetchEvents(requesterId: string, params: IParams): Promise<ISystemEventsMap> {
    const { containerIds, start, end } = params;

    const query = {
        ContainerIdList: containerIds.map((id) => {
            return {
                ContainerId: id
            };
        }),
        From: start.toISOString(),
        To: end.toISOString(),
    };

    return mavRequest.post(`event/get`, query).then((events) => {
        return events.reduce((r, cEvents) => {
            r[cEvents.ContainerId] = cEvents.EventList.filter((event) => {
                return event.Type != "SCAN_JOB_TERMINATED";
            });
            return r;
        }, {});
    });
}

function listEvents(requesterId: string, params: IParams): Function {
    return dispatch => {
        dispatch(new FSA(MAV.FETCH_EVENTS_REQUEST).addMeta({ requesterId }).data);

        return fetchEvents(requesterId, params).then((events: any) => {
            return dispatch(new FSA(MAV.FETCH_EVENTS_SUCCESS).addPayload(events).addMeta({ requesterId }).data);
        }, err => {
            dispatch(new FSA(MAV.FETCH_EVENTS_FAILURE).addError(err).addMeta({ requesterId }).data);
            throw err;
        });
    }
}

export {
    ISystemEvents,
    ISystemEventsMap,
    fetchEvents,
    listEvents,
};


// WEBPACK FOOTER //
// ./src/actions/mav/Event.ts